import apiPrd from '../../services/apiPrd'

const LoadsService = {
  async fetchLoadsByParams(params) {
    const res = await apiPrd.post('/shipping/search', params)
    return res.data
  },
  async markLoadAsDelivered(hashId, receiptPath, obs) {
    const res = await apiPrd.post(`shipping/${hashId}/closebytransporter?pathReceipt=${receiptPath}&observation=${obs}`)
    return res.data
  },
  async requestAuctionTime(hashIds) {
    const res = await apiPrd.get(`/shipping/requestResidualTime?shippingIds=${hashIds.join(',')}`)
    return res.data
  },
}

export default LoadsService
